import React from 'react';
import MenuCategoryItem from '../menu/MenuCategoryItem';
import CategoryMenuNavbar from './CategoryMenuNavbar';
import { PrematchContext } from '../Prematch';
import { labels } from '../../data/labels';

function CategoryMenu(props) {
    const prematchContext = React.useContext(PrematchContext);

    const items = prematchContext.applyTemporalFilter(props.sport.categories).map(function(c) {
        function handleClick() {
            prematchContext.openCategory(c);
        }
        return (
            <MenuCategoryItem key={c.id}
                                id={c.id}
                                desc={c.descrizione}
                                info={c.tournamentsCount}
                                sportRef={c.sportRef}
                                categoryRef={c.id}
                                iconClass={c.iconClass}
                                isLive={c.isLive}
                                action={handleClick}
                                urlPath={c.urlPath}
                                urlPathSuffix={c.urlPathSuffix}
                                urlPathSeo={c.urlPathSeo}
                                urlPathSeoSettings = {c.urlPathSeoSettings}  />
        );
    });

    return (
        <>
            <CategoryMenuNavbar sport={props.sport} />
            <div className="menu-container">
                {items.length > 0 ?
                    items
                    :
                    <div className="message-box">
                        <span className="list-element-text">{labels['prematch.tournament.no_categories']}</span>
                    </div>
                }
            </div>
        </>
    );
}

export default CategoryMenu;